import { type OpenApiSchemaProductCharacteristic } from '../../api/schema';
import { DELIMITER_DOT } from '../constants';

export type CharacteristicPartial = Pick<OpenApiSchemaProductCharacteristic, 'is_grouping' | 'title' | 'values'> & {
    id?: OpenApiSchemaProductCharacteristic['id'];
};

const getCharacteristicDisplayValue = (values: string[] | undefined): string =>
    values?.length ? values.join(', ') : '';

/*
 * Возвращает строку, состоящую из сгруппированных характеристик, объединенную через разделитель
 */
export const getGroupedCharacteristics = (characteristics: CharacteristicPartial[] | undefined, delimiter?: string) =>
    (characteristics || [])
        .reduce((acc: string[], { is_grouping: isGrouping, title, values }) => {
            if (!isGrouping) {
                return acc;
            }

            acc.push(title + ' ' + getCharacteristicDisplayValue(values));

            return acc;
        }, [])
        .join(delimiter || DELIMITER_DOT);

export const getAllCharacteristics = (characteristics: CharacteristicPartial[] | undefined, delimiter?: string) =>
    (characteristics || [])
        .map(({ title, values }) => title + ' ' + getCharacteristicDisplayValue(values))
        .join(delimiter || DELIMITER_DOT);

export const getAllCharacteristicsTitles = (characteristics: CharacteristicPartial[] | undefined, delimiter?: string) =>
    (characteristics || []).map(({ title }) => title).join(delimiter || DELIMITER_DOT);
